import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * Cluster Role Bindings — cluster-wide grants, so worth reviewing: a binding to
 * cluster-admin here gives full control of the cluster.
 *
 * The sidebar linked to /cluster-role-bindings with no route and no component, so it hit the
 * path="*" catch-all and silently landed on the Dashboard. This is that page.
 */
export default function ClusterRoleBindings() {
  return (
    <PagedWorkloadPage
      title="Cluster Role Bindings" kind="ClusterRoleBinding" resource="clusterrolebindings"
      label="cluster role bindings" detail={false} clusterScoped={true}
      cols={['Name', 'Role', 'Subjects', 'Age']}
      renderRow={b => [
        <td key="n"><Code>{b.name}</Code></td>,
        <td key="r" style={{
          fontSize: 12,
          // cluster-admin is unrestricted; make those bindings stand out on review.
          color: /cluster-admin/.test(b.role || '') ? 'var(--color-warning-500)' : 'inherit',
          fontWeight: /cluster-admin/.test(b.role || '') ? 600 : 400,
        }}>{b.role || '—'}</td>,
        <td key="s" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(b.subjects || []).join(', ') || '—'}
          {b.subject_count > (b.subjects || []).length && (
            <span> +{b.subject_count - (b.subjects || []).length} more</span>
          )}
        </td>,
        <td key="a"><Age ts={b.created_at} /></td>,
      ]}
    />
  );
}
